import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button } from '@mui/material'
import { Image } from '../../models/ImageModel'
import { APIImageUpload, buildAPIImageUpload } from "models/APIImageUpload";
import { CreateUrl, CallGetAPI, CallPostAPI, CallPutAPI } from 'Utils/ApiHelper.js';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';


interface Props {
    siteId: number | null
    lcLoggerId: number | null
    loggerId: number | null
    parent: string
    show: boolean
    images: APIImageUpload[]
    imageURLs: string[]
    toggleCopyModal: () => void
    serials: {
        serial: number
        id: number
    }[] | null
}




const ImageCopyModal: React.FC<Props> = ({ show, toggleCopyModal, images, parent, imageURLs, siteId, lcLoggerId, loggerId, serials }) => {


    const intl:IntlShape = useIntl()


    const [selectedImages, setSelectedImages] = useState<APIImageUpload[]>([])


    const handleImageClick = (imageData:APIImageUpload):void => {
        const selected = [...selectedImages]
        let useAzure = false
        if (selected.some(s => s.Id === "00000000-0000-0000-0000-000000000000")) {
            useAzure = true
        }
        if (useAzure) {
            if (selected.map(s => s.Filename).includes(imageData.Filename)) {
                const remainingImages = selected.filter(img => img.Filename !== imageData.Filename)
                setSelectedImages(remainingImages)
            } else {
                selected.push(imageData)
                setSelectedImages(selected)
            }
        } else {
            if (selected.map(s => s.Id).includes(imageData.Id)) {
                const remainingImages = selected.filter(img => img.Id !== imageData.Id)
                setSelectedImages(remainingImages)
            } else {
                selected.push(imageData)
                setSelectedImages(selected)
            }
        }
        
        
    }

    const handleCancel = ():void => {
        toggleCopyModal()
        setSelectedImages([])
    }

    const handleCopyImages = (): void => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                SiteId: siteId,
                ImageIds: selectedImages.map(img => img.Id),
                ImageFilenames: selectedImages.map(img => img.Filename)
            })
        }

        CallPostAPI(CreateUrl('/api/image/CopyImagesToSite'), requestOptions)
            .then(data => {
                createSuccessNotification()
                toggleCopyModal()
                setSelectedImages([])
            })
            .catch(err => {
                createErrorNotification()
                toggleCopyModal()
                setSelectedImages([])
                console.error(err)
            })
    }


    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert('callback');
        });
    };

    return (
        <Modal
            show={show}
            style={{ margin: "10px 0 200px 0", transform:  'translateX(16%)', zIndex: 1000000000}}
            className="modal-75w"
        >
            <Modal.Header>
                <Modal.Title>{intl.formatMessage({ id: "Select images to be copied to site" })}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'} }>
                    {imageURLs && imageURLs.length > 0 && imageURLs.map((imageURL: string, idx: number) => {
                        const imageData = images[idx]
                        let useAzure = false
                        if (imageData.Id === "00000000-0000-0000-0000-000000000000") {
                            useAzure = true
                        }

                        let selected;
                        if (!useAzure) {
                            selected = selectedImages && selectedImages.map(d => d.Id).includes(imageData.Id)
                        } else {
                            selected = selectedImages && selectedImages.map(d => d.Filename).includes(imageData.Filename)
                        }

                        let serial = 0
                        if (serials && serials.length > 0 && imageData) {
                            if (imageData.FkLCLoggerId) {
                                serial = serials.find(ser => ser.id === imageData.FkLCLoggerId + 500000).serial ?
                                    serials.find(ser => ser.id === imageData.FkLCLoggerId + 500000).serial : 0
                            } else {
                                serial = serials.find(ser => ser.id === imageData.FkLoggerId).serial ?
                                    serials.find(ser => ser.id === imageData.FkLoggerId).serial : 0
                            }
                        }
                        if (!imageData.ContentType.includes('pdf')) {
                            return (
                                <div key={!useAzure ? imageData.Id : imageData.Filename} style={{ position: 'relative' }}>
                                    <img src={imageURL} width="400" height="300" style={{ margin: 10, borderRadius: 25, border: selected ? '5px solid #00BF00' : 'none' }} onClick={():void => handleImageClick(imageData) } />
                                    {selected &&
                                        <div style={{
                                            background: '#00BF00',
                                            width: 20,
                                            height: 20,
                                            borderRadius: 1000,
                                            position: 'absolute',
                                            right: 20,
                                            top: 20,
                                            cursor: 'pointer'
                                        }}>
                                            <p style={{ color: 'white', margin: '-2px 0 0 6px' }}>{!useAzure ? selectedImages.findIndex(img => img.Id === imageData.Id) + 1 : selectedImages.findIndex(img => img.Filename === imageData.Filename) + 1}</p>
                                        </div>
                                    }
                                    {serials &&
                                        <div style={{
                                            position: 'absolute',
                                            bottom: 40,
                                            right: 20,
                                            background: '#ededed',
                                            borderRadius: '1000px',
                                            padding: '5px 10px'
                                        }}
                                        ><FormattedMessage id="Linked to serial"/>: <b>{serial}</b>
                                        </div>
                                    }
                                </div>
                            )
                        } else {
                            return (
                                <div key={imageData.Id} style={{ position: 'relative' }} onClick={(): void => handleImageClick(imageData)}>
                                <iframe
                                    style={{
                                        border: selected ? '5px solid #00BF00' : 'none',
                                        margin: 10,
                                        borderRadius: 25,
                                        width: "400px",
                                        height: "300px",
                                        overflow: "hidden",
                                        pointerEvents: "none",
                                        cursor: 'pointer'
                                        }}
                                    src={`${imageURL}#toolbar=0&navpanes=0&scrollbar=0`}
                                        
                                    />
                                    {selected &&
                                        <div style={{
                                            background: '#00BF00',
                                            width: 20,
                                            height: 20,
                                            borderRadius: 1000,
                                            position: 'absolute',
                                            right: 20,
                                            top: 20
                                        }}>
                                            <p style={{ color: 'white', margin: '-2px 0 0 6px' }}>{!useAzure ? selectedImages.findIndex(img => img.Id === imageData.Id) + 1 : selectedImages.findIndex(img => img.Filename === imageData.Filename) + 1}</p>
                                        </div>
                                    }
                                </div>
                            )
                        }
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="contained" color="primary" onClick={(): void => handleCopyImages()} style={{ marginRight: 10 }} disabled={selectedImages.length === 0}>{selectedImages.length === 0 ? intl.formatMessage({ id: 'Copy' }) : `${intl.formatMessage({ id: 'Copy' })} ${selectedImages.length} ${intl.formatMessage({ id: 'Files'})}`}</Button>
                <Button variant="contained" color="error" onClick={():void => handleCancel() }><FormattedMessage id='Cancel' /></Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ImageCopyModal